import React, { useState } from 'react'
import { SideNav, ListItem } from '@deere/ux.uxframe-react'
import { useTranslation } from "react-i18next";
import { CBAM, DEFAULT_LANGUAGE, LHR, TPSMEX } from '../utils/surveyLiterals';
import { ModalDocument } from '../components/modals/ModalDocument';
import cookie from "js-cookie";
import { getHelpDocPdf } from '../services/surveyHelpDoc.service';

export default function LeftRelatedLinks({surveyCode, url, setUrl, navMenuHeight, accessToken}) {
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();

    const navbarStyles = {
        width: '230px',
        maxWidth: '230px',
        top: navMenuHeight ? navMenuHeight + 16 : 0
    }

    const getHelpDocUrl = () => {
        if(!url && surveyCode === CBAM){
            getHelpDocPdf(accessToken, surveyCode, (cookie.get("i18next") || DEFAULT_LANGUAGE)).then(async (response) => {
                if(response.status === 200){
                    const blob = await response.blob();
                    const docUrl = window.URL.createObjectURL(blob);
                    setUrl(docUrl);
                }
            })
            .catch((err) => {
                console.log(err);
            });
      }
      setShowModal(true);
    }

    return (
        <>
            <SideNav className="d-sm-block mb-3 position-sticky fixed-top" style={navbarStyles} ariaLabel=''>
                <h5 className='ml-2 mt-2 font-weight-bold '>{t('lbl_related_links')}</h5>
                <ListItem key={'relatedLinks'} className='nav-item'>
                {surveyCode === LHR && (
                    <>
                        <a className={"nav-link "} target="_blank" rel="noreferrer" href={"https://investor.deere.com/governance/default.aspx?cid=VURL_suppliercode"}>{t("lbl_code_of_conduct")}</a>
                        <a className={"nav-link "} target="_blank" rel="noreferrer" href={"https://www.dhs.gov/uflpa-entity-list"}>{t("lbl_uflpa_list")}</a>
                    </>
                )}
                {(surveyCode === TPSMEX || surveyCode === CBAM) && (
                    <a className={"nav-link"} style={{cursor:"pointer"}} onClick={() => getHelpDocUrl()}>{t("lbl_Help_Doc")}</a>
                )}
                </ListItem>
            </SideNav>
            <ModalDocument 
                showModal={showModal}
                setShowModal={setShowModal}
                labelBtnPrimary={t("btn_close")}
                titleModal={t("lbl_Help_Doc")}
                iFrameUrl={url}
            />
        </>
    )
}